import type { Permission, UserRole } from "../types.ts";

export const timesheetPermission = {
    "timesheet-download:access": ["Employee"],
} satisfies Partial<Record<Permission, UserRole[]>>;